<template>
  <div v-if="item" class="h-100">
    <div class="product-single-card">
      <div class="product-top-area">
        <div class="product-discount" v-if="item.discount">
          {{ item.discount }} %%
        </div>
        <router-link :to="`/products/show/${item?.id}`" class="product-img">
          <div class="first-view">
            <img
              :src="item?.image"
              :alt="item?.name"
              class="img-fluid"
              onerror="this.src='https://i.ibb.co/qpB9ZCZ/placeholder.png'"
            />
          </div>
          <!-- <div class="hover-view">
            <img
              :src="item?.image"
              :alt="item?.name"
              class="img-fluid"
              onerror="this.src='https://i.ibb.co/qpB9ZCZ/placeholder.png'"
            />
          </div> -->
        </router-link>
        <div class="sideicons">
          <button class="sideicons-btn">
            <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon>
          </button>
          <button class="sideicons-btn">
            <v-icon class="edit" small @click="editItem(item)">
              fal fa-edit
            </v-icon>
          </button>
          <button class="sideicons-btn">
            <!-- <v-icon class="edit" small @click="deleteItem(item)">
              fal fa-trash
            </v-icon> -->
            <deleter name="products" :id="item.id" @refresh="$emit('reload')" />
          </button>
        </div>
      </div>
      <div class="product-info">
        <h6 class="product-category">
          <router-link :to="`/categories/show/${item.main_category.id}`"
            >{{ item?.main_category?.name }}
          </router-link>
        </h6>

        <h6 class="product-title text-truncate">
          <router-link :to="`/products/show/${item?.id}`">{{
            item?.name
          }}</router-link>
        </h6>
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-1">
            <div>
              <switcher
                name="product"
                :label="
                  item.is_active
                    ? this.$t('labels.hide_product')
                    : this.$t('show_product')
                "
                :item="item"
                value="is_active"
                type="active"
              />
            </div>
          </div>

          <div class="d-flex align-items-center gap-1">
            <!-- <div
              class="d-flex align-items-center"
              v-if="item?.rate_avg || item?.rate_avg == 0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-jewish-star"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#ffbf00"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 2l3 5h6l-3 5l3 5h-6l-3 5l-3 -5h-6l3 -5l-3 -5h6z" />
              </svg>
              <span class="review-count">({{ item?.rate_avg }})</span>
            </div> -->
            <button @click="show_details(item.id)" type="submit">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-arrows-maximize"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#ffbf00"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M16 4l4 0l0 4" />
                <path d="M14 10l6 -6" />
                <path d="M8 20l-4 0l0 -4" />
                <path d="M4 20l6 -6" />
                <path d="M16 20l4 0l0 -4" />
                <path d="M14 14l6 6" />
                <path d="M8 4l-4 0l0 4" />
                <path d="M4 4l6 6" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Start Image_Model -->
    <base-model @close="model_1.show_model = false" :show="model_1.show_model">
      <small-loader v-if="loading" />
      <div v-else>
        <v-data-table
          class="elevation-1 thumb strip"
          :headers="headers"
          :items="model_1.productSummaryData"
          :loading="loading"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          hide-default-footer
        >
          <!-- <template v-slot:no-data>
          {{ $t("table.noData", { name: $t("labels.orders") }) }}
        </template> -->

          <template v-slot:[`item.name`]="{ item }">
            <router-link v-if="item.name" :to="`/products/show/${item?.id}`">
              <span>
                {{ item.name }}
              </span>
            </router-link>
            <span class="redColor fontBold" v-else>{{ $t("notFound") }}</span>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            <span v-if="item.price">
              {{ item.price }} {{ $t("appCurrency") }}
            </span>

            <span class="redColor fontBold" v-else>{{ $t("notFound") }}</span>
          </template>
          <template v-slot:[`item.size`]="{ item }">
            <span v-if="item.size">
              {{ item.size.name }}
            </span>

            <span class="redColor fontBold" v-else>{{ $t("notFound") }}</span>
          </template>
          <template v-slot:[`item.color`]="{ item }">
            <div
              v-if="item.color.hex"
              :style="{
                backgroundColor: item.color.hex,
                width: '25px',
                height: '25px',
                borderRadius: '50%',
              }"
            ></div>
            <div v-else-if="item.color.image">
              <img
                :src="item?.color.image"
                :style="{
                  width: '25px',
                  height: '25px',
                  borderRadius: '50%',
                }"
                alt="color-image"
              />
            </div>

            <span class="redColor fontBold" v-else>{{ $t("notFound") }}</span>
          </template>
          <template v-slot:[`item.image`]="{ item }">
            <img class="image" :src="item?.image" v-if="item?.image" />
            <span class="redColor fontBold" v-else>{{ $t("notFound") }}</span>
          </template>
        </v-data-table>
        <div class="text-center">
          <button @click="showItem(item)" type="button">
            {{ $t("labels.view_details") }}
          </button>
        </div>
      </div>
    </base-model>
    <!-- End Image_Model -->
  </div>
</template>

<script>
import { cartIcon, usersIcon, dollarIcon, clockIcon } from "./Icons.js";

export default {
  name: "StatisticsCard",

  props: ["item", "rows", "color", "amount", "values", "progress"],
  data() {
    return {
      model_1: {
        show_model: false,
        productSummaryData: null,
      },
      loading: false,
      headers: [
        {
          text: this.$t("labels.image"),
          align: "center",
          value: "image",
          sortable: false,
        },
        // {
        //   text: this.$t("labels.product"),
        //   align: "center",
        //   value: "name",
        //   sortable: false,
        // },

        // {
        //   text: this.$t("labels.code"),
        //   align: "center",
        //   value: "code",
        //   sortable: false,
        // },
        {
          text: this.$t("labels.color"),
          align: "center",
          value: "color",
          sortable: false,
        },
        {
          text: this.$t("labels.size"),
          align: "center",
          value: "size",
          sortable: false,
        },
        {
          text: this.$t("labels.price"),
          align: "center",
          value: "price",
          sortable: false,
        },
        {
          text: this.$t("labels.quantity"),
          align: "center",
          value: "quantity",
          sortable: false,
        },
        // {
        //   text: this.$t("labels.total"),
        //   align: "center",
        //   value: "total_price",
        //   sortable: false,
        // },
      ],
    };
  },
  methods: {
    getIconComponent(key) {
      switch (key) {
        case "products":
          return cartIcon;
        case "clients":
          return usersIcon;
        case "total_revenue":
          return dollarIcon;
        case "total_orders":
          return clockIcon;
        default:
          return null;
      }
    },
    showItem(item) {
      this.$router.push({ path: `/products/show/` + item.id });
    },
    editItem(item) {
      this.$router.push({ path: `/products/edit/` + item.id });
    },
    deleteItem(item) {
      this.loading = true;

      this.axios({
        method: "Delete",
        url: `products/${item.id}`,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("sendSuccess"),
            position: "bottomRight",
          });

          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err?.response?.data?.message,
            position: "bottomRight",
          });
          this.loading = false;
        });
    },
    show_details(id) {
      this.loading = true;
      this.model_1.show_model = true;
      this.axios({
        method: "GET",
        url: `product-summary/${id}`,
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta?.last_page;
          this.paginations.items_per_page = res.data.meta?.per_page;
          this.total = res.data.meta?.total;
          this.model_1.productSummaryData = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          // console.log(err.response.data.messages);
          let message =
            err.response?.data.message ?? err.response?.data.messages;
          this.$iziToast.error({
            title: this.$t("validation.error"),
            message: message,
          });
          this.loading = false;
        });
    },
    defaultImage(index) {
      this.chats[
        index
      ].owner.avatar = require("@/assets/media/images/Avatars/no-user.png");
    },
  },
};
</script>

<style lang="scss" scoped>
.user-select-none {
  user-select: none;
}
a {
  text-decoration: none;
  color: unset;
}
.hide-text {
  font-size: 14px;
}
.review-count {
  font-size: 14px;
}
.review-star {
  color: #fdcc0d;
  font-size: 13px;
}
/* ===========
Product Single Card - Start
============= */
.product-single-card {
  padding: 20px;
  height: 100% !important;
  border-radius: 5px;
  box-shadow: 1px 1px 15px #cccccc40;
  transition: 0.5s ease-in;
  /* background-color: red; */
}

.product-single-card:hover {
  -webkit-box-shadow: 1px 1px 28.5px -7px #d6d6d6;
  -moz-box-shadow: 1px 1px 28.5px -7px #d6d6d6;
  box-shadow: 1px 1px 28.5px -7px #d6d6d6;
}

.product-single-card .product-info {
  padding: 15px 0 0 0;
}

.product-single-card .product-top-area {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 5px;
}

.product-single-card .product-top-area .product-discount {
  position: absolute;
  top: 10px;
  left: 10px;
  background: white;
  border-radius: 3px;
  padding: 5px 10px;
  box-shadow: 1px 1px 28.5px -7px #dddddd;
  user-select: none;
  z-index: 999;
}

.product-single-card .product-top-area .product-img {
  aspect-ratio: 1/1;
  overflow: hidden;
  height: 300px;
  width: 100%;
  .first-view {
    height: 100%;
    width: 100%;
    background-color: #000;
    img {
      width: 100%;
    }
  }
}

// .product-single-card .product-top-area:hover .product-img .first-view {
//   opacity: 0;
//   width: 0;
//   height: 0;

// }
// .product-single-card .product-top-area:hover .product-img .hover-view {
//   opacity: 100%;
//   scale: 1.2;
// }

.product-single-card .product-top-area .sideicons {
  position: absolute;
  right: 15px;
  display: grid;
  gap: 10px;
}

.product-single-card .product-top-area .sideicons .sideicons-btn {
  background-color: #fff;
  color: #000;
  border-radius: 50%;
  border: none;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transform: translateX(60px);
  transition: 0.3s ease-in;
  -webkit-box-shadow: 1px 1px 28.5px -7px #dddddd;
  -moz-box-shadow: 1px 1px 28.5px -7px #dddddd;
  box-shadow: 1px 1px 28.5px -7px #dddddd;
}

.product-single-card .product-top-area .sideicons .sideicons-btn:hover {
  color: #fff !important;
  background-color: var(--main);
}

.product-single-card .product-top-area .sideicons .sideicons-btn:nth-child(1) {
  transition-delay: 100ms;
}

.product-single-card .product-top-area .sideicons .sideicons-btn:nth-child(2) {
  transition-delay: 200ms;
}

.product-single-card .product-top-area .sideicons .sideicons-btn:nth-child(3) {
  transition-delay: 300ms;
}

.product-single-card .product-top-area .sideicons .sideicons-btn:nth-child(4) {
  transition-delay: 400ms;
}

.product-single-card .product-top-area:hover .sideicons .sideicons-btn {
  opacity: 100%;
  visibility: visible;
  transform: translateX(0);
}

.product-single-card .product-info .product-category {
  font-weight: 400;
  color: var(--main);
}

.product-single-card .product-info .product-title {
  font-size: 16px;
  font-weight: 600;
}

.product-single-card .product-info .old-price,
.product-single-card .product-info .new-price {
  padding-right: 15px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 1px;
}
.product-single-card .product-info .old-price {
  text-decoration: line-through;
  opacity: 70%;
}
/* ===========
Product Single Card - End
============= */
</style>
